import React from "react";

const PdfSection = () => {
  return (
    <iframe
      src="/UGC Committee.pdf"
      title="UGC Committee.pdf"
      className="w-screen h-screen"
    />
  );
};

export default PdfSection;